import script from "./treeFolder.vue?vue&type=script&setup=true&lang=js"
export * from "./treeFolder.vue?vue&type=script&setup=true&lang=js"

import "./treeFolder.vue?vue&type=style&index=0&id=b0a4de86&lang=css"

const __exports__ = script;

export default __exports__